import React, { Component } from 'react';

import DesktopResponsive from './responsive/Jobs/DesktopResponsive';
import MobileResponsive from './responsive/Jobs/MobileResponsive';

class Jobs extends Component {
  render() {
    return (
      <div>
        <DesktopResponsive history={this.props.history} />
        <MobileResponsive history={this.props.history} />
      </div>
    );
  }
}

export default Jobs;
